module.exports = __webpack_public_path__ + "static/media/switch-piece.c08a4bac.mp3";